module.exports = __webpack_public_path__ + "static/media/car.f1a4acfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/car.svg
// module id = 321
// module chunks = 0